// ════════════════════════════════════════════════════════════════════════════
//  features/fiscal/transporte/services/cteService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  CTeResumoDto,
  CTeDetalheDto,
  PaginadoCTeResponse,
  EmitirCTeRequest,
  EmitirCTeOsRequest,
  CancelarCTeRequest,
  CartaCorrecaoCTeRequest,
  TransmitirCTeResponse,
  ListaTransporteFiltros,
} from '../types';
import { paramsDaLista } from '../types';

const BASE_CTE   = '/api/v1/fiscal/cte';
const BASE_CTEOS = '/api/v1/fiscal/cte-os';

// ── CT-e mod 57 ───────────────────────────────────────────────────────────────

export const cteService = {
  /** Lista paginada; busca, situação, período de emissão e ordem são feitos no servidor. */
  listar: (pagina = 1, tamanhoPagina = 20, filtros: ListaTransporteFiltros = {}) =>
    apiClient
      .get<PaginadoCTeResponse>(BASE_CTE, { params: { pagina, tamanhoPagina, ...paramsDaLista(filtros) } })
      .then((r) => r.data),

  obterPorId: (id: number) =>
    apiClient.get<CTeDetalheDto>(`${BASE_CTE}/${id}`).then((r) => r.data),

  emitir: (req: EmitirCTeRequest) =>
    apiClient.post<TransmitirCTeResponse>(`${BASE_CTE}/emitir`, req).then((r) => r.data),

  cancelar: (id: number, req: CancelarCTeRequest) =>
    apiClient.post<TransmitirCTeResponse>(`${BASE_CTE}/${id}/cancelar`, req).then((r) => r.data),

  cartaCorrecao: (id: number, req: CartaCorrecaoCTeRequest) =>
    apiClient.post<TransmitirCTeResponse>(`${BASE_CTE}/${id}/carta-correcao`, req).then((r) => r.data),

  daCtePdfUrl: (id: number) => `${BASE_CTE}/${id}/dacte`,
};

// ── CT-e OS mod 67 ────────────────────────────────────────────────────────────

export const cteOsService = {
  /** Lista paginada; busca, situação, período de emissão e ordem são feitos no servidor. */
  listar: (pagina = 1, tamanhoPagina = 20, filtros: ListaTransporteFiltros = {}) =>
    apiClient
      .get<PaginadoCTeResponse>(BASE_CTEOS, { params: { pagina, tamanhoPagina, ...paramsDaLista(filtros) } })
      .then((r) => r.data),

  obterPorId: (id: number) =>
    apiClient.get<CTeDetalheDto>(`${BASE_CTEOS}/${id}`).then((r) => r.data),

  emitir: (req: EmitirCTeOsRequest) =>
    apiClient.post<TransmitirCTeResponse>(`${BASE_CTEOS}/emitir`, req).then((r) => r.data),

  cancelar: (id: number, req: CancelarCTeRequest) =>
    apiClient.post<TransmitirCTeResponse>(`${BASE_CTEOS}/${id}/cancelar`, req).then((r) => r.data),

  cartaCorrecao: (id: number, req: CartaCorrecaoCTeRequest) =>
    apiClient.post<TransmitirCTeResponse>(`${BASE_CTEOS}/${id}/carta-correcao`, req).then((r) => r.data),

  daCtePdfUrl: (id: number) => `${BASE_CTEOS}/${id}/dacte`,
};
